exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sidebarLogoFade-enter-active[data-v-61b0bf77]{-webkit-transition:opacity 1.5s;transition:opacity 1.5s}.sidebarLogoFade-enter[data-v-61b0bf77],.sidebarLogoFade-leave-to[data-v-61b0bf77]{opacity:0}.sidebar-logo-container[data-v-61b0bf77]{position:relative;width:100%;height:60px;line-height:60px;background:#fff;text-align:center;overflow:hidden}.sidebar-logo-container .sidebar-logo-link[data-v-61b0bf77]{height:100%;width:100%;margin-top:5px}.sidebar-logo-container .sidebar-logo-link .sidebar-logo[data-v-61b0bf77]{width:100px}", ""]);

// exports
